<template>
  <div class="eighthPage" :style="{height:screenHeight}">
    <span class="title text-center" :class="activeShow===8?'animate__animated animate__bounceInUp':''">APP下载</span>
    <div class="eigCodeCont">
      <van-row type="flex" justify="space-around">
        <van-col span="10" style="text-align: center" :class="activeShow===8?'animate__animated animate__fadeInLeft':''">
          <span class="text-grey">客户、商家端</span>
            <span class="eigCode" style="margin-top:10%;" @click="this.$goToUserClient">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/apple.png" style="margin-right: 8px"><span class="text-grey">IOS下载</span>
          </span>
            <span class="eigCode" @click="this.$goToUserClient">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/android.png" style="margin-right: 8px"><span class="text-grey">安卓下载</span>
          </span>
        </van-col>
          <van-col span="10" style="text-align: center" :class="activeShow===8?'animate__animated animate__fadeInRight':''">
              <span class="text-grey">骑手端</span>
              <span class="eigCode" style="margin-top:10%;" @click="this.$goToDriverClient">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/apple.png" style="margin-right: 8px"><span class="text-grey">IOS下载</span>
          </span>
              <span class="eigCode" @click="this.$goToDriverClient">
            <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/android.png" style="margin-right: 8px"><span class="text-grey">安卓下载</span>
          </span>
          </van-col>
      </van-row>
        <van-row type="flex" justify="space-around" style="margin-top:8%;" class="eightMobile">
            <van-col span="16">
                <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/mobile.png" :class="activeShow===8?'animate__animated animate__fadeInUp':''" style="width:100%;">
            </van-col>
            <van-col span="7" class="text-center" :class="activeShow===8?'animate__animated animate__fadeInTopRight':''">
                <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/gzhCode.png" style="width:100%;margin-top:10px;">
                <span class="text-grey" style="font-size:1em;">关注公众号</span>
                <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/gzhCode.png" style="width:100%;margin-top:20px;">
                <span class="text-grey">微信小程序</span>
            </van-col>
        </van-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'fourthPage',
    data(){
      return {
        screenHeight:0,
        screenWidth:0,
        activeIndex:0,
      }
    },
    props: {
      activeShow: Number
    },
    mounted(){
    },
    created(){
      this.screenHeight = document.documentElement.clientHeight+'px';
      this.screenWidth = document.documentElement.clientWidth+'px';
    },
    methods:{
      // 翻页方法 子传父
      moveSectionDown(){
        this.$emit('moveSectionDown');
      },
    }
  }
</script>
<style lang="less">
  .eighthPage{
    width:100%;
    float:left;
    .title{width:100%;float:left;font-size:1.6em;margin-top:18%;color:#555}
    .eigCodeCont{width:94%;margin-left:3%;background: #fff;float:left;margin-top:6%;padding-top:10%;}
    .eigCode{
        border:2px solid #ccc;width:60%;height:20px;float:left;margin-left:4%;padding:12px 25px;margin-bottom:12%;border-radius: 10px;
        *{
            vertical-align: middle;
        }
    }

  }
</style>
